
import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import { TranslatePipe } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { environment } from '../../../../environments/environment';
import { LanguageModalComponent } from '../language-modal/language-modal.component';

/**
 * This component holds the logic for the top menu.
 */
@Component({
    selector: 'app-modules-shared-top-menu',
    imports: [
    MatIconModule,
    MatMenuModule,
    RouterModule,
    TranslatePipe
],
    standalone: true,
    templateUrl: './top-menu.component.html',
    styleUrl: './top-menu.component.scss'
})
export class TopMenuComponent {
  // Inject MatDialog.
  private readonly dialog = inject(MatDialog);

  // Stores the app links.
  appLinks = [
    { name: 'serviceStatus', url: '' },
    { name: 'feedback', url: '/feedback' },
  ];

  /**
   * Opens language modal.
   */
  openLanguageModal(): void {
    this.dialog.open(LanguageModalComponent);
  }

  /**
   * Navigates to the cloudapp.
   */
  navigateTo(): void {
    window.location.href = environment.UrlEndpoints.cloudapp;
  }
}
